import React from 'react'
import "./Common_heading.css"

function Common_heading({headingText}) {
  return (
   <>
   <section className='Common_heading'>
    <h2>{headingText}</h2>
   </section>
   </>
  )
}

export default Common_heading